import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInheritLinkNew = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 16,
		height: 16,
		rx: 8,
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9 8C9 9.38071 7.88071 10.5 6.5 10.5H5.5C4.11929 10.5 3 9.38071 3 8C3 6.61929 4.11929 5.5 5.5 5.5H5.75M7 8C7 6.61929 8.11929 5.5 9.5 5.5H10.5C11.8807 5.5 13 6.61929 13 8C13 9.38071 11.8807 10.5 10.5 10.5H10.25",
		stroke: "white",
		strokeLinecap: "round"
	})]
});
export default SvgInheritLinkNew;
